import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { useLazyGetPackingListAnalyticsQuery } from '../../../../services/Api';
import React, { useEffect, useState } from 'react';
import LoaderSpiner from '../../../../components/loaderSpiner';

const COLORS = ['#FFC740', '#3D5972']; 

export default function PackingListsAnalytics() {
    const [trigger, { data, isLoading, error }] = useLazyGetPackingListAnalyticsQuery();
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        trigger(); 
    }, [trigger]);

    useEffect(() => {
        if (data?.data?.types) {
            const transformedData = data?.data?.types?.map(type => ({
                name: type.name,
                value: type.value,
            }));
            setChartData(transformedData); 
        }
    }, [data]);

    if (isLoading) return <LoaderSpiner/>;
    if (error) return <div>Error loading data.Try again later</div>;

    return (
        <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full">
            <h3 className="mb-4 font-['Roboto_Mono'] text-lg font-bold">Packing Lists Analytics</h3>
            <div className="flex justify-center items-center relative">
                <PieChart width={200} height={200}>
                    <Pie
                        data={chartData}
                        innerRadius={60}
                        outerRadius={80}
                        paddingAngle={0}
                        dataKey="value"
                    >
                        {chartData?.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index]} />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{ backgroundColor: '#fff', borderRadius: '8px' }}
                        labelStyle={{ fontWeight: 'bold' }}
                        itemStyle={{ color: '#333', fontWeight: 'bold' }}
                    />
                </PieChart>
                <div className="absolute flex flex-col justify-center items-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <p className="text-2xl font-bold">
                        {chartData?.length > 0 ? `${chartData[0].value.toFixed(1)}%` : '0%'}
                    </p>
                </div>
            </div>
            <div className="flex justify-center gap-4 mt-4">
                {chartData.map((entry, index) => (
                    <div
                        key={entry?.name}
                        className="flex items-center gap-2 font-['Quicksand'] text-sm font-medium"
                    >
                        <div
                            className="w-3 h-3 rounded-full"
                            style={{ backgroundColor: COLORS[index] }}
                        ></div>
                        <span className="text-sm">{entry?.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
